<template>
    <div id="shareholdingRatioEchart" style="width:100%;height:340px;box-shadow:0px 2px 9px 0px rgba(212,212,212,0.5);">

    </div>
</template>
<script>
export default {
    name:'shareholdingRatioEchart',
    data(){
        return{}
    },
    props: {
      title: String,
      data: Array,
    },
    methods: {
      init(){
        this.$nextTick(function () {
          let data=this.data
          let monthData=[]
          let colorArr = ['#56b5ff', '#fdd158', '#bee485', '#9de8f6', '#f5736e']
          for (let i = 0; i < data.length; i++) {
            monthData.push({value: data[i].shouldCapi, name: data[i].stockName,itemStyle:{color:colorArr[i]}})
          }
          var echarts = require('echarts');
          var myChart = echarts.init(document.getElementById('shareholdingRatioEchart'));
          var option = {
            title:{
              text:'持股比例(%)',
              y:'20',
              x:'20'
            },

            tooltip: {
              trigger: 'item',
              formatter: '{b} : {c} ({d}%)'
            },
            series: [
              {
                type: 'pie',
                radius: '40%',
                center: ['50%', '60%'],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                },
                // labelLine: {
                //     normal: {
                //         show: false,
                //     }
                // },
                data: monthData
              }
            ]
          };
          myChart.setOption(option)
        })
      },
    },
    watch:{
      data:function () {
        this.init()
      },
    },
    mounted () {
      this.init()
    }
}
</script>
<style lang="scss" scoped>

</style>
